// React
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Functions
import { translate, tranStr } from "../../utils/translation";

// Components
import BenchmarkCreateSelectionModal from "../benchmarking/BenchmarkCreateSelectionModal";
import Modal, { AutoCloseModal } from "../modal/Modal";

// API
import { updateBenchmarkComparisons } from "../../api/estimates/EstimateBenchmarkAPI";
import { hasRoles } from "../../utils/roles";

BenchmarkCollectionsComparisons.propTypes = {
  user: PropTypes.object,
  benchmarking: PropTypes.array,
  selectedCollection: PropTypes.object,
  setSelectedCollection: PropTypes.func,
  benchmarkCollections: PropTypes.object,
};

export default function BenchmarkCollectionsComparisons(props) {
  const [isComparisonsOpen, setIsComparisonsOpen] = useState(false);

  const { user } = props;
  const { benchmarking } = props;
  const { selectedCollection, setSelectedCollection } = props;
  const { benchmarkCollections } = props;

  const [benchmarkSelectionFilters, setBenchmarkSelectionFilters] = useState(
    {}
  );

  const [benchmarkSelection, setBenchmarkSelection] = useState(
    selectedCollection.benchmarkComparisons || []
  );

  useEffect(() => {
    setBenchmarkSelection(selectedCollection.benchmarkComparisons);
  }, [selectedCollection]);

  const [error, setError] = useState({});

  if (hasRoles(user.roles, ["Client"])) {
    return null;
  }

  return (
    <div>
      <button
        className="button general-upload-button"
        onClick={() => {
          setIsComparisonsOpen(!isComparisonsOpen);
        }}
      >
        Select Projects
      </button>
      <Modal
        title={translate("Select Benchmarks")}
        Component={BenchmarkCreateSelectionModal}
        modal={isComparisonsOpen}
        setModal={setIsComparisonsOpen}
        // Props
        user={user}
        // Requirements
        error={error}
        benchmarkSelectionFilters={benchmarkSelectionFilters}
        setBenchmarkSelectionFilters={setBenchmarkSelectionFilters}
        benchmarkSelection={benchmarkSelection}
        setBenchmarkSelection={setBenchmarkSelection}
        benchmarks={benchmarking}
        onSave={async () => {
          await saveBenchmarkComparisons(
            selectedCollection,
            setSelectedCollection,
            benchmarkSelection,
            benchmarkCollections,
            setIsComparisonsOpen,
            setError
          );
        }}
      />
    </div>
  );
}

async function saveBenchmarkComparisons(
  selectedCollection,
  setSelectedCollection,
  benchmarkSelection,
  benchmarkCollections,
  setIsComparisonsOpen,
  setError
) {
  const benchmarkIds = benchmarkSelection?.map((s) => ({
    BenchmarkId: s.id,
    IsAnonymous: true,
  }));

  const data = {
    projectId: selectedCollection?.id,
    benchmarkId: selectedCollection?.id,
    benchmarkComparisonIds: benchmarkIds,
    setModal: setIsComparisonsOpen,
    setError: setError,
    // Mocking dependency
    CPs: {
      get: () => null,
      set: () => null,
    },
  };

  setError({
    text: tranStr("Saving..."),
    type: "feedback-success",
  });
  let isSaved = await updateBenchmarkComparisons(data);

  if (isSaved) {
    setError({
      text: tranStr("Saved Successfully"),
      type: "feedback-success",
    });

    // Retrieve the collections after the update to refresh the UI
    const benchmarkCollectionsData = await benchmarkCollections.get();
    const updatedSelectedCollection = benchmarkCollectionsData.data.find(
      (c) => c.id === selectedCollection.id
    );
    // Set the selected collection again with the updated values
    setSelectedCollection(updatedSelectedCollection);
    // Update the list of collections as well
    benchmarkCollections.set(benchmarkCollectionsData);
    AutoCloseModal(data.setModal);
    setError({});
  } else {
    setError({
      text: tranStr("Save Failed"),
      type: "feedback-error",
    });
  }
}
